import { useFlag } from '@calendly/feature-check-react'
import { useSelector } from 'react-redux'

import {
  isAvailableSelector,
  isExternalFormsAvailableSelector,
  isSalesforceRoutingAvailableSelector,
  isHubspotRoutingAvailableSelector,
  isTeamsHubspotRoutingAvailableSelector
} from 'features/routing/selectors'

export const useBillingFeaturesAccess = () => {
  const isRoutingFormsAvailable = useSelector(isAvailableSelector)
  const isExternalFormsAvailable = useSelector(isExternalFormsAvailableSelector)
  const isBetaSalesforceRoutingFlagEnabled = useFlag('raven_salesforce_routing_feature')
  const isSalesforceRoutingAvailable = useSelector(isSalesforceRoutingAvailableSelector)
  const isHubspotRoutingAvailable = useSelector(isHubspotRoutingAvailableSelector)
  const isTeamsHubspotRoutingAvailable = useSelector(isTeamsHubspotRoutingAvailableSelector)

  return {
    isRoutingFormsAvailable,
    isExternalFormsAvailable,
    isSalesforceRoutingAvailable: isBetaSalesforceRoutingFlagEnabled || isSalesforceRoutingAvailable,
    isHubspotRoutingAvailable: isTeamsHubspotRoutingAvailable || isHubspotRoutingAvailable
  }
}
